import { render, staticRenderFns } from "./emailSettingsBlock.vue?vue&type=template&id=69fbc820&scoped=true&"
import script from "./emailSettingsBlock.vue?vue&type=script&lang=js&"
export * from "./emailSettingsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fbc820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
